import paymentTypes from '../types/payment';
import apiPaymentUat from "../../api/apiPaymentUat";
import apiPayment from "../../api/apiPayment";
import {logDOM} from "@testing-library/react";
import paymentStore from "../reducer/payment";
import {useSelector} from "react-redux";

const setPaymentModalOpen = (boolean) => ({
    type: paymentTypes.SET_PAYMENT_MODAL_OPEN,
    boolean,
});
const setPaymentStepsOpen = (boolean) => ({
    type: paymentTypes.SET_PAYMENT_STEPS_OPEN,
    boolean,
});
const setPaymentResult = (string) => ({
    type: paymentTypes.SET_PAYMENT_RESULT,
    string,
});
const setPaymentError = (payload) => ({
    type: paymentTypes.SET_PAYMENT_ERROR,
    payload,
});
const setPaymentErrorCount = (payload) => ({
    type: paymentTypes.SET_PAYMENT_ERROR_COUNT,
    payload,
});
const setPaymentConfirmationId = (payload) => ({
    type: paymentTypes.SET_PAYMENT_CONFIRMATION_ID,
    payload,
});
const setStepFirstDone = (boolean) => ({
    type: paymentTypes.SET_STEP_FIRST_DONE,
    boolean,
});
const setStepSecondDone = (boolean) => ({
    type: paymentTypes.SET_STEP_SECOND_DONE,
    boolean,
});
const setStepThirdDone = (boolean) => ({
    type: paymentTypes.SET_STEP_THIRD_DONE,
    boolean,
});
const setStepFourthDone = (boolean) => ({
    type: paymentTypes.SET_STEP_FOURTH_DONE,
    boolean,
});
const setUser = (object) => ({
    type: paymentTypes.SET_USER,
    object,
});
const setPaymentType = (string) => ({
    type: paymentTypes.SET_PAYMENT_TYPE,
    string,
});
const setPaymentAmount = (string) => ({
    type: paymentTypes.SET_PAYMENT_AMOUNT,
    string,
});
const setPaymentCustomAmount = (string) => ({
    type: paymentTypes.SET_PAYMENT_CUSTOM_AMOUNT,
    string,
});
const setPaymentMethod = (string) => ({
    type: paymentTypes.SET_PAYMENT_METHOD,
    string,
});
const setPaymentCardNumber = (string) => ({
    type: paymentTypes.SET_PAYMENT_CARD_NUMBER,
    string,
});
const setPaymentCardNumberSpaced = (string) => ({
    type: paymentTypes.SET_PAYMENT_CARD_NUMBER_SPACED,
    string,
});
const setPaymentCardNumberError = (string) => ({
    type: paymentTypes.SET_PAYMENT_CARD_NUMBER_ERROR,
    string,
});
const setPaymentMonth = (string) => ({
    type: paymentTypes.SET_PAYMENT_MONTH,
    string,
});
const setPaymentMonthError = (string) => ({
    type: paymentTypes.SET_PAYMENT_MONTH_ERROR,
    string,
});
const setPaymentYear = (string) => ({
    type: paymentTypes.SET_PAYMENT_YEAR,
    string,
});
const setPaymentYearError = (string) => ({
    type: paymentTypes.SET_PAYMENT_YEAR_ERROR,
    string,
});
const setPaymentCvv = (string) => ({
    type: paymentTypes.SET_PAYMENT_CVV,
    string,
});
const setPaymentCvvError = (string) => ({
    type: paymentTypes.SET_PAYMENT_CVV_ERROR,
    string,
});
const setPaymentFirstName = (string) => ({
    type: paymentTypes.SET_PAYMENT_FIRST_NAME,
    string,
});
const setPaymentFirstNameError = (string) => ({
    type: paymentTypes.SET_PAYMENT_FIRST_NAME_ERROR,
    string,
});
const setPaymentAddress = (string) => ({
    type: paymentTypes.SET_PAYMENT_ADDRESS,
    string,
});
const setPaymentAddressError = (string) => ({
    type: paymentTypes.SET_PAYMENT_ADDRESS_ERROR,
    string,
});
const setPaymentState = (string) => ({
    type: paymentTypes.SET_PAYMENT_STATE,
    string,
});
const setPaymentStateError = (string) => ({
    type: paymentTypes.SET_PAYMENT_STATE_ERROR,
    string,
});
const setPaymentCity = (string) => ({
    type: paymentTypes.SET_PAYMENT_CITY,
    string,
});
const setPaymentCityError = (string) => ({
    type: paymentTypes.SET_PAYMENT_CITY_ERROR,
    string,
});
const setPaymentZipCode = (string) => ({
    type: paymentTypes.SET_PAYMENT_ZIP_CODE,
    string,
});
const setPaymentZipCodeError = (string) => ({
    type: paymentTypes.SET_PAYMENT_ZIP_CODE_ERROR,
    string,
});
const setPaymentBankAccount = (string) => ({
    type: paymentTypes.SET_PAYMENT_BANK_ACCOUNT,
    string,
});
const setPaymentBankAccountError = (string) => ({
    type: paymentTypes.SET_PAYMENT_BANK_ACCOUNT_ERROR,
    string,
});
const setPaymentBankAccountName = (string) => ({
    type: paymentTypes.SET_PAYMENT_BANK_ACCOUNT_NAME,
    string,
});
const setPaymentBankAccountNameError = (string) => ({
    type: paymentTypes.SET_PAYMENT_BANK_ACCOUNT_NAME_ERROR,
    string,
});
const setPaymentRoutingNumber = (string) => ({
    type: paymentTypes.SET_PAYMENT_ROUTING_NUMBER,
    string,
});
const setPaymentRoutingNumberError = (string) => ({
    type: paymentTypes.SET_PAYMENT_ROUTING_NUMBER_ERROR,
    string,
});
const setPaymentAccountType = (string) => ({
    type: paymentTypes.SET_PAYMENT_ACCOUNT_TYPE,
    string,
});
const setPaymentAccountTypeError = (string) => ({
    type: paymentTypes.SET_PAYMENT_ACCOUNT_TYPE_ERROR,
    string,
});
const setConfirmType = (string) => ({
    type: paymentTypes.SET_CONFIRM_TYPE,
    string,
});
const setConfirmEmail = (string) => ({
    type: paymentTypes.SET_CONFIRM_EMAIL,
    string,
});
const setConfirmCustomEmail = (string) => ({
    type: paymentTypes.SET_CONFIRM_CUSTOM_EMAIL,
    string,
});
const setFormAccountNumber = (string) => ({
    type: paymentTypes.SET_FORM_ACCOUNT_NUMBER,
    string,
});
const setFormZipCode = (string) => ({
    type: paymentTypes.SET_FORM_ZIP_CODE,
    string,
});
const setFormError = (string) => ({
    type: paymentTypes.SET_FORM_ERROR,
    string,
});
const setLoading = (boolean) => ({
    type: paymentTypes.SET_LOADING,
    boolean,
});
const setAccountFormLoading = (boolean) => ({
    type: paymentTypes.SET_ACCOUNT_FORM_LOADING,
    boolean,
});

const sendFormAccountVerification = (accountNumber, zipCodeRaw) => async (dispatch) => {
    dispatch(setAccountFormLoading(true))

    const accountNumbersNoZero = +accountNumber;
    let zipCode = zipCodeRaw.replace('-','');
    apiPaymentUat.get(`/customer?account=${accountNumbersNoZero}&zip=${zipCode}`).then(response => formResult(response)).catch(err =>
        formError(err));

    const formResult = (response) => {
        if (response.data.accountNumber) {
            const user = {
                accountNumber: response.data.accountNumber,
                fullName: response.data.fullName,
                minimumDue: parseAmount(response.data.minimumDue),
                pastDue: response.data.pastDue,
                dueDate: response.data.dueDate,
                balance: parseAmount(response.data.balance),
                email: response.data.email,
            };
            dispatch(setFormAccountNumber(''));
            dispatch(setFormZipCode(''));
            dispatch(setUser(user));
            dispatch(setPaymentStepsOpen(true));
            dispatch(setAccountFormLoading(false));

        } else {
            dispatch(setAccountFormLoading(false));
            dispatch(setFormError('No matches'));
        }
    }

    const formError = (err) => {
        console.log(err)
        dispatch(setAccountFormLoading(false));
        dispatch(setFormError('No matches'));
    }

    return null;
};

const sendPaymentCard = (paymentData) => async (dispatch) => {
    dispatch(setLoading(true))

    const dateString = `${paymentData['month']}/1/${paymentData['year']}`;
    const dateObj = new Date(dateString);

    const data = {
        "rvosAccountNumber": paymentData['accountNumber'],
        "fullName": paymentData['fullName'],
        "amount": paymentData['amount'],
        "cardNumber": paymentData['cardNumber'],
        "expirationDate": dateObj.toISOString(),
        "nameOnCard": paymentData['firstName'],
        "billingStreet": paymentData['address'],
        "billingAdditional": paymentData['address'],
        "billingCity": paymentData['city'],
        "billingState": paymentData['state'],
        "postalCode": paymentData['zipCode'],
        "cardCVV": paymentData['cvv'],
        "dueDate": paymentData['dueDate'],
        "sendReceipt": paymentData['sendReceipt'],
        "sendReceiptToEmail": paymentData['sendReceiptToEmail'],
    };

    try {
        let res = await apiPayment.post(`/payment/card`, JSON.stringify(data))
        if (+res.data.reasonCode === 100) {
            await dispatch(setPaymentResult('success'));
            dispatch(setPaymentConfirmationId(res.data.id))
        } else {
            dispatch(setPaymentError(res.data.replyMessage));
            dispatch(setPaymentErrorCount());
        }
    } catch (err) {
        dispatch(setPaymentError(err.response.data.detail));
        dispatch(setPaymentErrorCount());
    }
    dispatch(setLoading(false))
}

const sendPaymentEft = (paymentData) => async (dispatch) => {
    dispatch(setLoading(true))
    const data = {
        "routingNumber": paymentData.routingNumber,
        "accountNumber": paymentData.accountNumber,
        "accountType": paymentData.accountType,
        "accountName": paymentData.accountName,
        "rvosAccountNumber": paymentData.rvosAccountNumber,
        "amount": paymentData.amount,
        "fullName": paymentData.fullName,
        "dueDate": paymentData['dueDate'],
        "sendReceipt": paymentData['sendReceipt'],
        "sendReceiptToEmail": paymentData['sendReceiptToEmail'],
    };

    try {
        let res = await apiPayment.post(`/payment/eft`, JSON.stringify(data))
        await dispatch(setPaymentResult('success'));
        dispatch(setPaymentConfirmationId(res.data.id))
    } catch (err) {
        dispatch(setPaymentError(err.response.data.detail));
        dispatch(setPaymentErrorCount());
    }

    // try {
    //     let res = await apiPayment.post(`/payment/eft`, JSON.stringify(data));
    //     await dispatch(setPaymentResult('success'));
    //     dispatch(setPaymentConfirmationId(res.data.id));
    // } catch (err) {
    //     if (err.response.data.violations && err.response.data.violations.length > 0) {
    //         const firstViolation = err.response.data.violations[0];
    //         const propertyPath = firstViolation.propertyPath;
    //         const message = firstViolation.message;
            
    //         dispatch(setPaymentError(propertyPath, message));

    //     } else {
    //         dispatch(setPaymentError(err.response.data.detail));
    //     }
    //     dispatch(setPaymentErrorCount());
    // }


    dispatch(setLoading(false))
}

const parseAmount = (value) => {
    let result = value.replace('$', '');
    result = result.replace(',', '');
    return parseFloat(result);
}

const closePayment = () => async (dispatch) => {
    dispatch(setPaymentModalOpen(false));
    dispatch(setLoading(false));
    dispatch(setAccountFormLoading(false));
    dispatch(setFormZipCode(''));
    dispatch(setUser(null));
    dispatch(setPaymentStepsOpen(false));
    dispatch(setPaymentResult(null));
    dispatch(setPaymentError(''));
    dispatch(setPaymentErrorCount(0));
    dispatch(setPaymentConfirmationId(null));
    dispatch(setStepSecondDone(false));
    dispatch(setStepThirdDone(false));
    dispatch(setStepFourthDone(false));
    dispatch(setUser(null));
    dispatch(setPaymentType(''));
    dispatch(setPaymentAmount(''));
    dispatch(setPaymentCustomAmount(''));
    dispatch(setPaymentMethod(''));
    dispatch(setPaymentCardNumber(''));
    dispatch(setPaymentCardNumberSpaced(''));
    dispatch(setPaymentCardNumberError(''));
    dispatch(setPaymentMonth(''));
    dispatch(setPaymentMonthError(''));
    dispatch(setPaymentYear(''));
    dispatch(setPaymentYearError(''));
    dispatch(setPaymentCvv(''));
    dispatch(setPaymentCvvError(''));
    dispatch(setPaymentFirstName(''));
    dispatch(setPaymentFirstNameError(''));
    dispatch(setPaymentAddress(''));
    dispatch(setPaymentAddressError(''));
    dispatch(setPaymentCity(''));
    dispatch(setPaymentCityError(''));
    dispatch(setPaymentState(''));
    dispatch(setPaymentStateError(''));
    dispatch(setPaymentZipCode(''));
    dispatch(setPaymentZipCodeError(''));
    dispatch(setPaymentBankAccount(''));
    dispatch(setPaymentBankAccountError(''));
    dispatch(setPaymentBankAccountName(''));
    dispatch(setPaymentBankAccountNameError(''));
    dispatch(setPaymentRoutingNumber(''));
    dispatch(setPaymentRoutingNumberError(''));
    dispatch(setPaymentAccountType(''));
    dispatch(setPaymentAccountTypeError(''));
    dispatch(setConfirmType(''));
    dispatch(setConfirmEmail(''));
    dispatch(setConfirmCustomEmail(''));
    dispatch(setFormAccountNumber(''));
    dispatch(setFormZipCode(''));
    dispatch(setFormError(''));
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
}

export default {
    setPaymentModalOpen,
    setPaymentStepsOpen,
    setPaymentResult,
    setPaymentError,
    setPaymentErrorCount,
    setStepFirstDone,
    setStepSecondDone,
    setStepThirdDone,
    setStepFourthDone,
    setUser,
    setPaymentType,
    setPaymentAmount,
    setPaymentCustomAmount,
    setPaymentMethod,
    setPaymentCardNumber,
    setPaymentCardNumberSpaced,
    setPaymentCardNumberError,
    setPaymentMonth,
    setPaymentMonthError,
    setPaymentYear,
    setPaymentYearError,
    setPaymentCvv,
    setPaymentCvvError,
    setPaymentFirstName,
    setPaymentFirstNameError,
    setPaymentAddress,
    setPaymentAddressError,
    setPaymentState,
    setPaymentStateError,
    setPaymentCity,
    setPaymentCityError,
    setPaymentZipCode,
    setPaymentZipCodeError,
    setPaymentBankAccount,
    setPaymentBankAccountError,
    setPaymentBankAccountName,
    setPaymentBankAccountNameError,
    setPaymentRoutingNumber,
    setPaymentRoutingNumberError,
    setPaymentAccountType,
    setPaymentAccountTypeError,
    setConfirmType,
    setConfirmEmail,
    setConfirmCustomEmail,
    setFormAccountNumber,
    setFormZipCode,
    setFormError,
    sendFormAccountVerification,
    sendPaymentCard,
    sendPaymentEft,
    closePayment,
    setLoading
};
